import React from 'react';

const TopComponent = (props) => {     
    return (
        props.top && props.top.HeaderTitle?
            <div className="bg-white border-bottom">
                <div className="container"> 
                        <div className="top content">
                            <div className="text-left top-header" > <a href={props.top.headerTitleURL} className="color-red"> {props.top.HeaderTitle} </a></div>
                        </div>
                    </div>

                </div> 
            : ''


    );
};

export default TopComponent;